module.exports = __webpack_public_path__ + "3bc49f156fe9c9ecb8c94f74c15dfeb0.svg";